import ApplicationController from '@aha-app/mvc';
import WhiteboardController from '../../controllers/WhiteboardController';

class UrlInputModalController extends ApplicationController<
  {},
  { fabricObject: fabric.Object }
> {
  actionHideModal() {
    const whiteboardController =
      this.findControllerInstance(WhiteboardController)!;
    whiteboardController.actionHideUrlInputModal();
  }

  actionConfirm(url: string) {
    if (url) {
      const validatedUrl = this.validatedUrl(url);
      if (validatedUrl) {
        this.props.fabricObject.set('linkToUrl', validatedUrl);
      }
    }

    this.actionHideModal();
  }

  actionClear() {
    this.actionHideModal();
    this.props.fabricObject.set('linkToUrl', '');
  }

  /** Validate the url and return a properly formatted version, or null if invalid */
  validatedUrl(url: string): string | null {
    let validatedUrl = url;

    // Check if URL has protocol, if not add https://
    if (!validatedUrl.match(/^https?:\/\//)) {
      validatedUrl = `https://${validatedUrl}`;
    }

    try {
      // This will throw an error if the URL is invalid
      void new URL(validatedUrl);
    } catch {
      // URL is invalid, don't hide the modal
      return null;
    }

    return validatedUrl;
  }
}

export default UrlInputModalController;
